import React from 'react';
import PropTypes from 'prop-types';
import {Button, Text} from 'rebass'
import {Backdrop, InlineBlock, Overlay} from "reakit";
// import {DesktopBox, MobileBox} from "../Base";
import styled from "styled-components";

const StyledOverlay = styled(Overlay)`
	min-width: 150px;
	min-height: 110px;
`

const MobileConfirmLocationPermission = props => {

	const {handleConfirm, visible, toggle} = props;

	return (
		<Overlay.Container>
			{overlay => (
				<InlineBlock>
					<Backdrop fade use={Overlay.Hide} {...overlay} visible={visible} onClick={toggle} zIndex={1100}/>
					<StyledOverlay fade slide {...overlay} visible={visible} zIndex={1200} >
						<Text>Wave needs permission to access your location when you press the Panic Button for emergency. </Text>
                        <Text>We won't access it in the background.</Text>
						<Button variant={'approve'} p={1} m={1} bg={'red'} onClick={() => {
							handleConfirm()
							toggle()
						}}>Yes</Button>
					</StyledOverlay>
				</InlineBlock>
			)}
		</Overlay.Container>
	);
};

MobileConfirmLocationPermission.propTypes = {
	handleConfirm: PropTypes.func,
	toggle: PropTypes.func,
	visible: PropTypes.bool,
	noButton: PropTypes.bool
};

MobileConfirmLocationPermission.defaultProps = {
	handleConfirm: () => console.log('clicked confirm delete'),
	visible: false,
	noButton: false
};

export default MobileConfirmLocationPermission;
